/**
 * Rejeição usada quando o usuário cancela/fecha um modal (ex.:
 * ModalQuestionService). NÃO representa um erro real — cancelar um modal é um
 * caminho legítimo do usuário e não deve gerar issue no Sentry.
 *
 * A mensagem carrega a marca `[modal-dismissed]`, usada pelo filtro
 * `ignoreErrors` no Sentry.init (core.module.ts) para descartar tanto a
 * unhandled rejection (quando o caller não trata) quanto o log de console
 * correspondente. Callers que quiserem distinguir o cancelamento de um erro
 * real podem usar `instanceof ModalDismissedError`.
 */
export class ModalDismissedError extends Error {
  constructor() {
    super('[modal-dismissed] Modal cancelado pelo usuário');
    this.name = 'ModalDismissedError';
  }
}
